import { apiNetworking } from 'services/apiService';

export const getEdgeTypes = async () => {
  const { data } = await apiNetworking.get('/edge/types');
  return data;
};

export const getEdges = async (
  from_user_uuid: string,
  to_user_uuid: string,
  from_node_type?: string,
  to_node_type?: string
) => {
  const { data } = await apiNetworking.get('/edge/find', {
    params: { from_user_uuid, to_user_uuid, from_node_type, to_node_type },
  });
  return data;
};

export const createEdge = async (
  from_user_uuid: string,
  to_user_uuid: string,
  type_code: string,
  value?: string,
  from_node_type?: string,
  to_node_type?: string
) => {
  const { data } = await apiNetworking.post('/edge/create', {
    from_user_uuid,
    to_user_uuid,
    type_code,
    value,
    from_node_type,
    to_node_type,
  });
  return data;
};

export const removeEdge = async (edge_id: number) => {
  return apiNetworking.delete(`/edge/remove/${edge_id}`);
};

export const getUserStats = async (userId: string) => {
  const { data } = await apiNetworking.get(`/stats/user/${userId}`);
  return data;
};
